import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderSort, IFilter, Logic, Operator } from 'core-components/types'
import Logger from 'core/utils/Logger'

import { getJbpMasterDealerDataCrud } from './helpers/getJbpMasterDealerDataCrud'
import { mapEPRecordFromJBPMasterDealerDataView } from './mapping'

interface IFetchMDDataParams {
  partnerId?: string
  options?: ICrudFetchOptions
}

export const fetchMDData = ({ partnerId = '', options }: IFetchMDDataParams) => {
  const crud = getJbpMasterDealerDataCrud(options?.cacheKey)
  const filterByPartnerId: IFilter[] = [
    {
      field: 'MDPartnerId',
      operator: Operator.EQUAL,
      value: partnerId,
    },
    {
      field: 'EPPartnerId',
      operator: Operator.ISNOTNULL,
      value: '',
    },
  ]

  const filters = {
    logic: Logic.AND,
    filters: partnerId ? filterByPartnerId : [],
  }

  const sort: IDataProviderSort = {
    field: 'EntryId',
    dir: 'desc',
  }

  crud.setDefaultFilter(filters)
  crud.setSort(sort)
  crud.setPaging({
    page: 0,
    pageSize: 1000,
  })

  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items) {
        return result.items.map(mapEPRecordFromJBPMasterDealerDataView)
      }

      return []
    })
    .catch((e) => {
      Logger.error(e)
      return []
    })
}
